import { type PersonalRecordDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"

export class PersonalRecordEntity {
  id: string
  userId: string
  movementId: string
  value: number
  repetitionMax: number | null
  date: Date
  comment: string | null

  private constructor(entity: PersonalRecordEntity) {
    this.id = entity.id
    this.userId = entity.userId
    this.movementId = entity.movementId
    this.value = entity.value
    this.repetitionMax = entity.repetitionMax
    this.date = entity.date
    this.comment = entity.comment
  }

  static fromDto(dto: PersonalRecordDto): PersonalRecordEntity {
    return new PersonalRecordEntity({
      id: dto.id,
      userId: dto.userId,
      movementId: dto.movementId,
      value: dto.value,
      repetitionMax: dto.repetitionMax,
      date: new Date(dto.date),
      comment: dto.comment,
    })
  }
}
